import { useQuery } from "react-query";
import { getAdditionalDiagnoses } from "api/customers";
import { GET_ADDITIONAL_DIAGNOSES } from "@constants/reactQueryKeys";

const useGetAdditionalDiagnoses = (clientId: number | null) => {
  const { data, isLoading, refetch } = useQuery(
    [GET_ADDITIONAL_DIAGNOSES, clientId],
    () => getAdditionalDiagnoses(clientId!),
    { enabled: Boolean(clientId) }
  );

  return {
    additionalDiagnoses: data?.data ?? [],
    isAdditionalDiagnosesLoading: isLoading,
    refetchAdditionalDiagnoses: refetch,
  };
};

export default useGetAdditionalDiagnoses;
